<template>
  <div :class="$style.container">
    <template v-if="isSupported">
      <!-- <BaseButton v-if="!isRecording" @click="start">start</BaseButton>
      <BaseButton v-else @click="stop">stop</BaseButton> -->
      <button
        :class="[$style.button, { [$style.rec]: isRecording }]"
        @click="toggleRec"
      >
        <BaseIcon :name="isRecording ? 'stop' : 'microphone'" />
      </button>
    </template>
    <div v-else>Audio recording is not supported by your browser</div>
    <BaseIcon
      custom name="close"
      :class="$style.close"
      @click="$emit('close')"
    />
  </div>
</template>

<script>
import MicRecorder from 'mic-recorder-to-mp3'

const getDuration = (src) => {
  return new Promise(resolve => {
    var audio = new Audio()
    audio.addEventListener('loadedmetadata', () => {
      resolve(audio.duration * 1000)
    })
    audio.src = src
  })
}

export default {
  name: 'chat-voice-recorder',
  props: {
    outputFormat: {
      type: String,
      default: 'mp3'
    }
  },
  data () {
    return {
      recorder: null,
      isRecording: false,
      isSupported: true
    }
  },
  created () {
    window.AudioContext = window.AudioContext || window.webkitAudioContext
    if (!window.AudioContext) {
      this.isSupported = false
    }
  },
  methods: {
    async start () {
      this.recorder = this.recorder || new MicRecorder({
        bitRate: 128
      })
      this.recorder.start()
      this.isRecording = true
    },
    async stop () {
      if (!this.recorder) return
      this.isRecording = false
      const [buffer] = await this.recorder.stop().getMp3()
      const file = new File(buffer, `audio.${this.outputFormat}`, {
        type: `audio/${this.outputFormat}`,
        lastModified: Date.now()
      })
      const duration = await getDuration(URL.createObjectURL(file))
      this.$emit('recorded', {
        file,
        duration
      })
    },
    toggleRec () {
      if (this.isRecording) {
        this.stop()
        return
      }
      this.start()
    }
  }
}
</script>

<style module lang="scss">
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-grow: 1;
}
.close {
  color: $text-mid;
  cursor: pointer;
  font-size: 14px;
  position: absolute;
  top: 10px;
  right: 10px;
}
.button {
  width: 55px;
  height: 55px;
  background-color: $text-error;
  border: 0;
  border-radius: 50%;
  outline: none;
  color: $text-lightest;
  cursor: pointer;
  font-size: 24px;
  &.rec {
    // background-color: rgba($text-error, 0.7);
    animation-name: pulse;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0px 0px 5px 0px rgba($text-error,.3);
  }
  65% {
    box-shadow: 0px 0px 5px 13px rgba($text-error,.3);
  }
  90% {
    box-shadow: 0px 0px 5px 13px rgba($text-error,0);
  }
}
</style>
